import debug from "debug";
const logger = debug("open-attestation");
export const getLogger = (namespace) => ({
    trace: logger.extend(`trace:${namespace}`),
    debug: logger.extend(`debug:${namespace}`),
    info: logger.extend(`info:${namespace}`),
    warn: logger.extend(`warn:${namespace}`),
    error: logger.extend(`error:${namespace}`),
});
